import axios from 'axios';

// Get base URL from env, or fallback to dummy online if not local
const API_BASE = process.env.REACT_APP_API_BASE_URL || 
  (window.location.hostname === 'localhost' ? 'http://localhost/lms/api' : 'https://dummy-online-link.com/api');

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('lms_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle unauthorized access
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token and fire event for AuthContext to log user out
      localStorage.removeItem('lms_token');
      localStorage.removeItem('lms_user');
      window.dispatchEvent(new Event('auth-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;
